import React, { useMemo, useState } from "react";
import {
  Accordion,
  Button,
  Checkbox,
  Form,
  FormField,
  FormGroup,
  Icon,
  Input,
  Modal,
  Segment,
  SemanticWIDTHS,
} from "semantic-ui-react";
import ButtonLoadCheck from "react-lib/appcon/common/ButtonLoadCheck";
import FormMobEditOrderDetail from "react-lib/apps/HISV3/common/FormMobEditOrderDetail";
//STYLE
import { formatPrice } from "react-lib/apps/common/PureReactTable";
import "react-lib/apps/HISV3/common/CardOrderSetTemplate.scss";
import {
  MasterOptionsType,
  OrderSetTemplateType,
  SetProp,
  supplyMode,
  templateList,
  TemplateKey,
  SelectTemplateType,
  CheckBoxTemplateType,
  eligibilityTypeOptions,
  urgencyOptions,
} from "./sequence/OrderSetTemplate";

const CARD_ORDER_SET_TEMPLATE = "CardOrderSetTemplateUX";

// Styles
const COLORS = {
  lightGreen: "#ADFFB8",
  darkGreen: "#1B9D2C",
};

const orderDetailHeader = [
  { name: "ชื่อ", width: "five" },
  { name: "รายละเอียด", width: "six" },
  { name: "จำนวน", width: "two" },
  { name: "ราคาต่อหน่วย", width: "two" },
  { name: "ราคารวม", width: "two" },
  { name: "", width: "two" },
];

const addOrderDetailHeader = [
  { name: "checkbox", width: "one" },
  { name: "รหัส", width: "two" },
  { name: "รายการ", width: "six" },
  { name: "จำนวน", width: "one" },
  { name: "รายละเอียด", width: "six" },
];

const headerModal = {
  PROC: "หัตการ",
  SUPPLY: "เวชภัณฑ์",
  LAB: "แลป",
  XRAY: " Imaging",
  OTHER: "รายละเอียดค่าใช้จ่ายเบ็ดเตล็ด",
};

type FormOrderDetailListProps = {
  runSequence: (e: any) => any;
  setProp: SetProp;
  // data
  buttonLoadCheck?: Record<string, any>;
  OrderSetTemplateSequence?: OrderSetTemplateType;
  isAddTemplate?: boolean;
  // options
  masterOptions?: MasterOptionsType;
  masterData?: MasterOptionsType;
  supplyOrderEligibilityOptions?: any[];
};

const FormOrderDetailList = (props: FormOrderDetailListProps) => {
  const [selectedId, setSelectedId] = useState<any>(null);
  const [activeIndex, setActiveIndex] = useState<number[]>([0, 1, 2, 3, 4]);

  const headerList = props.isAddTemplate ? addOrderDetailHeader : orderDetailHeader;

  const accordionData = useMemo(() => {
    return [
      {
        name: "Lab",
        key: "LAB",
        list: props.OrderSetTemplateSequence?.selectTemplate?.lab_template_list || [],
      },
      {
        name: "X-ray",
        key: "XRAY",
        list: props.OrderSetTemplateSequence?.selectTemplate?.imaging_template_list || [],
      },
      {
        name: "Treatment",
        key: "PROC",
        list: props.OrderSetTemplateSequence?.selectTemplate?.treatment_template_list || [],
      },
      {
        name: "Supply",
        key: "SUPPLY",
        list: props.OrderSetTemplateSequence?.selectTemplate?.supply_template_list || [],
      },
      {
        name: "Miscellaneous",
        key: "OTHER",
        list: props.OrderSetTemplateSequence?.selectTemplate?.miscellaneous_template_list || [],
      },
    ];
  }, [
    props.OrderSetTemplateSequence?.selectTemplate?.lab_template_list,
    props.OrderSetTemplateSequence?.selectTemplate?.imaging_template_list,
    props.OrderSetTemplateSequence?.selectTemplate?.treatment_template_list,
    props.OrderSetTemplateSequence?.selectTemplate?.supply_template_list,
    props.OrderSetTemplateSequence?.selectTemplate?.miscellaneous_template_list,
  ]);

  const isCheckAll = useMemo(() => {
    const {
      selectTemplate = {} as SelectTemplateType,
      checkBoxTemplate = {} as CheckBoxTemplateType,
    } = props.OrderSetTemplateSequence || {};

    const {
      lab_template_list = [],
      imaging_template_list = [],
      treatment_template_list = [],
      supply_template_list = [],
      miscellaneous_template_list = [],
    } = selectTemplate;

    const totalTemplateLength =
      lab_template_list.length +
      imaging_template_list.length +
      treatment_template_list.length +
      supply_template_list.length +
      miscellaneous_template_list.length;

    if (totalTemplateLength === 0) {
      return false;
    }

    const { LAB = [], XRAY = [], PROC = [], SUPPLY = [], OTHER = [] } = checkBoxTemplate;

    const isLabChecked = lab_template_list.length === LAB.length;
    const isImagingChecked = imaging_template_list.length === XRAY.length;
    const isTreatmentChecked = treatment_template_list.length === PROC.length;
    const isSupplyChecked = supply_template_list.length === SUPPLY.length;
    const isOTHERChecked = miscellaneous_template_list.length === OTHER.length;

    return (
      isLabChecked && isImagingChecked && isTreatmentChecked && isSupplyChecked && isOTHERChecked
    );
  }, [props.OrderSetTemplateSequence]);

  const handleSeletedData = (data: any, key: TemplateKey) => {
    setSelectedId(data?.id);

    props.runSequence({
      sequence: "OrderSetTemplate",
      action: "getDetailData",
      data: data,
      key: key,
    });
  };

  const handleDeleteData = (id: number, key: TemplateKey) => {
    props.setProp(
      `OrderSetTemplateSequence.selectTemplate.${templateList[key]}`,
      props.OrderSetTemplateSequence?.selectTemplate?.[templateList[key]]?.filter(
        (item: any) => item.id !== id
      )
    );
  };

  const handleEditOrderDetail = () => {
    props.runSequence({
      sequence: "OrderSetTemplate",
      action: "editOrderDetail",
      selectedId: selectedId,
      callback: (id: any) => {
        setSelectedId(id);
      },
    });
  };

  const orderTemplateListDetail = (type: string, data: any) => {
    if (type === "Treatment") {
      let icd9Detail = data?.icd9 ? `[${data?.icd9?.icd10_id}] ${data?.icd9?.icdterm} ,` : "";

      return `${icd9Detail} ${data?.toBePerformer || ""}`;
    } else if (type === "Supply") {
      let mode = data?.mode
        ? `${
            data?.mode && data?.mode in supplyMode
              ? supplyMode[data?.mode as keyof typeof supplyMode]
              : ""
          } ,`
        : "";
      let eligibilityType =
        eligibilityTypeOptions?.filter((item: any) => item.value === data?.eligibility_type)?.[0]
          ?.text || "";

      return `${mode} ${eligibilityType}`;
    } else if (type === "Lab") {
      const urgencyType =
        urgencyOptions?.filter((item: any) => item.value === data?.urgency)?.[0]?.text || "";

      const specimenType =
        (props.masterData?.specimenList || [])?.filter(
          (item) => item?.code === data?.specimen_code
        )?.[0]?.name || "";

      return (
        <div style={{ display: "flex" }}>
          <div style={{ display: "flex" }}>
            {data?.specimen_color && (
              <div
                style={{
                  backgroundColor: data?.specimen_color,
                  borderRadius: "50%",
                  width: "1.5em",
                  height: "1.5em",
                  margin: "0px 10px",
                }}
              ></div>
            )}
            {data?.specimen_code && <div>{`[${specimenType}] ,`}</div>}
          </div>
          <div>{`${urgencyType}`}</div>
        </div>
      );
    } else if (type === "X-ray") {
      let xrayGroup = data?.xrayGroup ? `${data?.xrayGroup} ,` : "";
      let urgencyType =
        urgencyOptions?.filter((item: any) => item.value === data?.urgency)?.[0]?.text || "";

      return `${xrayGroup} ${urgencyType}`;
    } else if (type === "Miscellaneous") {
      let eligibilityType =
        eligibilityTypeOptions?.filter((item: any) => item.value === data?.eligibility_type)?.[0]
          ?.text || "";

      return `${eligibilityType}`;
    } else {
      return "";
    }
  };

  const orderTemplateListCount = (type: string, data: any) => {
    return `${Number(data?.quantity) || 0} ${
      props.masterData?.unit.find((item: Record<string, any>) => item.id === data?.unit)?.text ?? ""
    }`;
  };

  const orderTemplateListSomePrice = (type: string, data: any) => {
    let quantity = 0;

    quantity = Number(data?.quantity || 0);

    return formatPrice(quantity * Number(data?.price_normal || 0));
  };

  const handleClickAccordion = (e: any, data: any) => {
    const index = Number(data.index);
    const newIndex = activeIndex.includes(data.index)
      ? activeIndex.filter((idx) => index !== idx)
      : [...activeIndex, index];

    setActiveIndex(newIndex);
  };

  const handleCheckAll = (e: any, data: any) => {
    const newCheckBoxTemplate = (Object.keys(templateList) as TemplateKey[]).reduce((acc, key) => {
      const list = props.OrderSetTemplateSequence?.selectTemplate?.[templateList[key]] || [];

      acc[key] = data.checked
        ? list
            .map((item: { id?: number }) => item.id)
            .filter((id): id is number => id !== undefined)
        : [];

      return acc;
    }, {} as Record<TemplateKey, number[]>);

    props.setProp("OrderSetTemplateSequence.checkBoxTemplate", newCheckBoxTemplate);
  };

  const handleCheckHeader = (type: TemplateKey) => (e: any, data: any) => {
    const templateKey = templateList[type];

    const list = props.OrderSetTemplateSequence?.selectTemplate?.[templateKey] || [];

    const ids = data.checked
      ? (list as { id?: number }[])
          .map((item) => item.id)
          .filter((id): id is number => id !== undefined)
      : [];

    props.setProp(`OrderSetTemplateSequence.checkBoxTemplate.${type}`, ids);
  };

  const handleCheckData = (type: TemplateKey, id: number) => (e: any, data: any) => {
    const currentList = props.OrderSetTemplateSequence?.checkBoxTemplate?.[type] || [];

    const newList = data.checked ? [...currentList, id] : currentList.filter((item) => item !== id);

    props.setProp(`OrderSetTemplateSequence.checkBoxTemplate.${type}`, newList);
  };

  const handleChangeQuantity = (type: TemplateKey, id: number) => (e: any, v: any) => {
    const templateKey = templateList[type];

    props.setProp(
      `OrderSetTemplateSequence.selectTemplate.${templateKey}.${id}.quantity`,
      Number(v.value.replace(/\D/g, ""))
    );
  };

  const closeFormMobEdit = () => {
    props.setProp("OrderSetTemplateSequence", {
      ...props.OrderSetTemplateSequence,
      searchIcd9: [],
      selectDetail: {},
    });
  };

  return (
    <>
      <Form>
        {/* Header */}
        <FormGroup inline style={{ marginBottom: "0px", background: "#D6ECF3" }}>
          {headerList.map(({ name, width }) => {
            const isCheckbox = name === "checkbox";

            return (
              <FormField inline width={width as SemanticWIDTHS} key={name}>
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    margin: "5px",
                    fontWeight: "bold",
                    justifyContent: "center",
                  }}
                >
                  {isCheckbox ? (
                    <Checkbox
                      className="checkbox-green"
                      onChange={handleCheckAll}
                      checked={isCheckAll}
                    />
                  ) : (
                    name || ""
                  )}
                </div>
              </FormField>
            );
          })}
        </FormGroup>

        {/* Data */}
        <FormGroup inline>
          <FormField width={16} inline style={{ padding: "0px" }}>
            <div
              style={{
                width: "100%",
                height: props.isAddTemplate ? "calc(70dvh - 7.5rem)" : "calc(55dvh - 7.5rem)",
                overflow: "auto",
              }}
            >
              <Accordion>
                {accordionData
                  .filter((item) => item.list?.length > 0)
                  .map((item: any, index: number) => {
                    const key = item?.key as "LAB" | "XRAY" | "PROC" | "SUPPLY" | "OTHER";
                    const templateKey = templateList[key];
                    const selectTemplate =
                      props.OrderSetTemplateSequence?.selectTemplate?.[templateKey] || [];
                    const checkBoxTemplate =
                      props.OrderSetTemplateSequence?.checkBoxTemplate?.[key] || [];
                    return (
                      <div style={{ borderBottom: "1px solid #0072BC" }}>
                        <Accordion.Title
                          active={activeIndex.includes(index)}
                          index={index}
                          style={{
                            color: "#0072BC",
                          }}
                          onClick={handleClickAccordion}
                        >
                          <Form>
                            <FormGroup inline>
                              <FormField
                                inline
                                width={1}
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  ...(!props.isAddTemplate && {
                                    display: "none",
                                  }),
                                }}
                              >
                                <div>
                                  <Checkbox
                                    className="checkbox-green"
                                    onClick={(e) => e.stopPropagation()}
                                    onChange={handleCheckHeader(key)}
                                    checked={selectTemplate?.length === checkBoxTemplate?.length}
                                  />
                                </div>
                              </FormField>
                              <FormField>
                                <div style={{ fontSize: "16px", color: "#2185d0" }}>
                                  <Icon
                                    color="blue"
                                    name={
                                      activeIndex.includes(index)
                                        ? "chevron circle down"
                                        : "chevron circle right"
                                    }
                                    style={{ marginRight: "0px 10px" }}
                                  />
                                  {`${item?.name} ${
                                    item?.list?.length > 0 ? `(${item?.list?.length})` : ""
                                  }`}
                                </div>
                              </FormField>
                            </FormGroup>
                          </Form>
                        </Accordion.Title>
                        <Accordion.Content active={activeIndex.includes(index)}>
                          <Form>
                            {(item?.list || []).map((data: any, listIndex: number) => {
                              return props.isAddTemplate ? (
                                <FormGroup inline>
                                  <FormField inline width={1}>
                                    <div
                                      style={{
                                        display: "flex",
                                        width: "100%",
                                        justifyContent: "center",
                                      }}
                                    >
                                      <Checkbox
                                        className="checkbox-green"
                                        onChange={handleCheckData(key, data?.id)}
                                        checked={checkBoxTemplate.includes(data?.id)}
                                      ></Checkbox>
                                    </div>
                                  </FormField>
                                  <FormField inline width={2}>
                                    <div
                                      style={{
                                        width: "100%",
                                        marginLeft: "10px",
                                        ...(checkBoxTemplate.includes(data?.id) && {
                                          color: COLORS.darkGreen,
                                        }),
                                      }}
                                    >
                                      {data.code}
                                    </div>
                                  </FormField>
                                  <FormField inline width={6}>
                                    <div
                                      style={{
                                        width: "100%",
                                        marginLeft: "10px",
                                        ...(checkBoxTemplate.includes(data?.id) && {
                                          color: COLORS.darkGreen,
                                        }),
                                      }}
                                    >
                                      {data?.name}
                                    </div>
                                  </FormField>
                                  <FormField inline width={1}>
                                    <div
                                      style={{
                                        width: "100%",
                                      }}
                                    >
                                      <Input
                                        className={
                                          checkBoxTemplate.includes(data?.id) ? "input-green" : ""
                                        }
                                        value={data?.quantity}
                                        fluid
                                        name="quantity"
                                        onChange={handleChangeQuantity(key, listIndex)}
                                      />
                                    </div>
                                  </FormField>
                                  <FormField inline width={6}>
                                    <div
                                      style={{
                                        width: "100%",
                                        marginLeft: "10px",
                                        ...(checkBoxTemplate.includes(data?.id) && {
                                          color: COLORS.darkGreen,
                                        }),
                                      }}
                                    >
                                      {orderTemplateListDetail(item?.name, data)}
                                    </div>
                                  </FormField>
                                </FormGroup>
                              ) : (
                                <FormGroup inline>
                                  <FormField inline width={5}>
                                    <div
                                      style={{
                                        width: "100%",
                                      }}
                                    >
                                      {`[${data.code}] ${data?.name}`}
                                    </div>
                                  </FormField>
                                  <FormField inline width={6}>
                                    <div
                                      style={{
                                        width: "100%",
                                      }}
                                    >
                                      {orderTemplateListDetail(item?.name, data)}
                                    </div>
                                  </FormField>
                                  <FormField inline width={2}>
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        width: "100%",
                                      }}
                                    >
                                      {orderTemplateListCount(item?.name, data)}
                                    </div>
                                  </FormField>
                                  <FormField inline width={2}>
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        width: "100%",
                                      }}
                                    >
                                      {formatPrice(data?.price_normal || 0)}
                                    </div>
                                  </FormField>
                                  <FormField inline width={2}>
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        width: "100%",
                                      }}
                                    >
                                      {orderTemplateListSomePrice(item?.name, data)}
                                    </div>
                                  </FormField>
                                  <FormField inline width={2}>
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        width: "100%",
                                      }}
                                    >
                                      <Button
                                        size="small"
                                        color="yellow"
                                        icon
                                        onClick={() => handleSeletedData(data, key)}
                                      >
                                        <Icon name="edit outline" />
                                      </Button>
                                      <Button
                                        size="small"
                                        color="red"
                                        icon
                                        onClick={() => handleDeleteData(data?.id, key)}
                                      >
                                        <Icon name="minus" />
                                      </Button>
                                    </div>
                                  </FormField>
                                </FormGroup>
                              );
                            })}
                          </Form>
                        </Accordion.Content>
                      </div>
                    );
                  })}
              </Accordion>
            </div>
          </FormField>
        </FormGroup>
      </Form>

      <Modal
        Modal
        open={!!props.OrderSetTemplateSequence?.selectDetail?.id}
        size={"small"}
        onClose={closeFormMobEdit}
      >
        <Segment
          inverted
          style={{ backgroundColor: "var(--primary-theme-color)", fontWeight: "bold" }}
        >
          {`รายละเอียดการสั่ง${
            headerModal[props.OrderSetTemplateSequence?.selectDetail?.p_type_code as TemplateKey] ||
            "รายละเอียดค่าใช้จ่ายเบ็ดเตล็ด"
          }`}
        </Segment>
        <FormMobEditOrderDetail
          runSequence={props.runSequence}
          setProp={props.setProp}
          OrderSetTemplateSequence={props.OrderSetTemplateSequence}
          masterOptions={props.masterOptions}
          masterData={props.masterData}
          supplyOrderEligibilityOptions={props.supplyOrderEligibilityOptions}
        />
        <div style={{ display: "flex", justifyContent: "flex-end", margin: "20px 10px" }}>
          <ButtonLoadCheck
            // function
            setProp={props.setProp}
            onClick={handleEditOrderDetail}
            // data
            paramKey={`${CARD_ORDER_SET_TEMPLATE}_EditOrderDetail`}
            buttonLoadCheck={props.buttonLoadCheck?.[`${CARD_ORDER_SET_TEMPLATE}_EditOrderDetail`]}
            // config
            color="green"
            size="small"
            title={"บันทึก"}
          />
          <Button color="red" size="small" onClick={closeFormMobEdit}>
            ยกเลิก
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default React.memo(FormOrderDetailList);
